module.exports = __webpack_public_path__ + "img/waitingMaintenance.7d13e28e.svg";